export function listTeam(params) {
    return window.axios.post("api/team/list", params)
}
export function clearTeam(params) {
    return window.axios.post("api/team/clear", params)
}
export function deleteTeam(id) {
    return window.axios.post("api/team/delete", { id: id })
}
export function batchDeleteTeam(id) {
    return window.axios.post("api/team/batchDelete", { ids: id })
}
export function updateTeam(params) {
    return window.axios.post("api/team/update", params)
}
export function addTeam(params) {
    return window.axios.post("api/team/add", params)
}
export function getTeam(id) {
    return window.axios.post("api/team/get", { id: id })
}
export function exportTeam(params) {
    let config = {
        responseType: "blob"
    }
    return window.axios.post("api/team/export/excel", params, config)
}
export function exportTeamConfig() {
    return window.axios.post("api/team/exportConfig", {})
}
